import React, { useState } from 'react'
import HOC from '../../components/HOC/HOC'
import addjob from '../../css/style.module.css'
import { useNavigate } from 'react-router-dom'
import { SuccessfullyModal } from '../../components/Modals/Modals'


const EditVouchersOffers = () => {
    const navigate = useNavigate()
    const [show, setShow] = useState(false)
    const handlemodal = () => {
        setShow(true)
        setTimeout(() => {
            setShow(false);
            navigate(-1)
        }, 2000);
    }

    return (
        <>
            <SuccessfullyModal
                show={show}
                handleClose={() => setShow(false)}
                text={"Successfully Updated"}
            />
            <div className={addjob.jobmanagementCotainer}>
                <div className={addjob.jobtoppart}>
                    <div className={addjob.pagetitle}>
                        <h6>Edit Vouchers & Offers</h6>
                    </div>
                    <div className={addjob.rightbuttons}>
                        <div className={addjob.rightbuttons2} onClick={() => navigate(-1)}>
                            <p>View Vouchers & Offers</p>
                        </div>
                    </div>
                </div>

                <div className={addjob.addjobcontainer}>
                    <div className={addjob.addjobsubcontainer}>
                        <div className={addjob.addjobtopic}>
                            <h6>Offer Details</h6>
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Create Offer Name*</label>
                            <input type="text" placeholder='JOBFEST' />
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Code*</label>
                            <input type="text" placeholder='JOB670' />
                        </div>
                        <div className={addjob.addjobinputs}>
                            <label htmlFor="">Discount*</label>
                            <input type="text" placeholder='50%' />
                        </div>
                        <div className={addjob.addnewbanner}>
                            <div className={addjob.addjobtopic}>
                                <h6>Validity</h6>
                            </div>
                            <div className={addjob.addvouchercontainer}>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">Start Date *</label>
                                    <input type="date" placeholder='Please enter Staters' />
                                </div>
                                <div className={addjob.addjobinputs}>
                                    <label htmlFor="">End Date*</label>
                                    <input type="date" placeholder='Please enter Staters' />
                                </div>
                            </div>
                        </div>

                    </div>
                    <div className={addjob.addjobbutton}>
                        <div className={addjob.rightbuttons}>
                            <button onClick={() => navigate(-1)}>Cancel</button>
                        </div>
                        <div className={addjob.rightbuttons}>
                            <button onClick={handlemodal} style={{ background: '#F05423' }}>Update</button>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default HOC(EditVouchersOffers)